import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type QuotingIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const QuotingIcon = ({ ...props }: QuotingIconProps) => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      stroke="none"
      d="M12.1929 2.16274C11.9759 1.94575 11.6241 1.94575 11.4071 2.16274L4 9.56985V10.356L4.78565 10.3558L12.1929 2.94853C12.4099 2.73154 12.4099 2.37973 12.1929 2.16274ZM9.99289 0.748528C10.9909 -0.249509 12.6091 -0.24951 13.6071 0.748528C14.6051 1.74656 14.6051 3.3647 13.6071 4.36274L5.90711 12.0627C5.71965 12.2502 5.46543 12.3555 5.20033 12.3556L2 12.3567V9.15563C2 8.89042 2.10536 8.63606 2.29289 8.44853L9.99289 0.748528Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      stroke="none"
      d="M11.7928 5.56265L8.79282 2.56265L10.207 1.14844L13.207 4.14844L11.7928 5.56265Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" stroke="none" d="M16 16H0V14H16V16Z" />
  </BaseIcon>
);

QuotingIcon.displayName = 'QuotingIcon';
